export default "__VITE_ASSET__CxWUiW8T__"